export const setInvestmentText = (investType) => {
    let headingText = "";
    let investTypeText = "";
    switch (investType){
            case "stock":
                headingText = "Stock";
                investTypeText = "stock";
                break;
            case "bond":
                headingText = "Bond";
                investTypeText = "bond";
                break;
            case "index":
                headingText = "Index Fund";
                investTypeText = "index fund";
                break;
            case "mutualfund":
                headingText = "Mutual Fund";
                investTypeText = "mutual fund";
                break;
            default:
                break;
        }
    const returnObj = {headingText: headingText, investTypeText: investTypeText};
    return returnObj;
}

export default setInvestmentText;